import { CmRadio, CmRadioGroup, CmStack, CmText } from '@/components/uiParts';

export type FilterType = 'all' | 'unconfigured' | 'configured';

type FilterOptionsProps = {
  filterType: FilterType;
  onChange: (value: FilterType) => void;
};

export const FilterOptions: React.FC<FilterOptionsProps> = ({
  filterType,
  onChange,
}) => {
  return (
    <CmRadioGroup
      onChange={(value) => onChange(value as FilterType)}
      value={filterType}
    >
      <CmStack direction="row" spacing={6}>
        <CmRadio value="all" size="md">
          <CmText>全てのアカウント</CmText>
        </CmRadio>
        <CmRadio value="unconfigured" size="md">
          <CmText>未設定のみ</CmText>
        </CmRadio>
        <CmRadio value="configured" size="md">
          <CmText>設定済のみ</CmText>
        </CmRadio>
      </CmStack>
    </CmRadioGroup>
  );
};
